document.querySelectorAll('.fuse-drop__header').forEach(header => {
    const eyebrow = header.querySelector('.fuse-drop__eyebrow');
    const title = header.querySelector('.fuse-drop__title');

    if (!title) return;

    const text = title.textContent.trim().toUpperCase();
    const text_2 = eyebrow.textContent.trim().toUpperCase();

    if (text === 'SUNLIGHTS' || text_2 === 'SUNLIGHTS') {
        title.classList.add('sunlights');
        eyebrow?.classList.add('sunlights');
    } else if (text === 'STILL STANDING' || text_2 === 'TILL STANDING') {
        title.classList.add('still_standing');
        eyebrow?.classList.add('still_standing');
    } else if (text === 'REBUILT' || text_2 === 'REBUILT') {
        title.classList.add('rebuilt');
        eyebrow?.classList.add('rebuilt');
    }
});

(function() {
  console.log("🚀 Ajuste de Hero");

  function getViewportHeight() {
    return window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;
  }

  function getHeaderHeight() {
    const headerGroup = document.getElementById('header-group');
    if (!headerGroup) return 0;

    let height = 0;

    for (let child of headerGroup.children) {
      const rect = child.getBoundingClientRect();

      if (rect.height > 0) {
        height += rect.height;
      }
    }

    return height;
  }

  function setHeroHeight() {
    const hero = document.querySelector('.hero-wrapper .hero');

    if (!hero) {
      console.warn("⛔ Hero no encontrado");
      return;
    }

    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const viewportHeight = getViewportHeight();

    let availableHeight;

    if (isMobile) {
      // 📱 MOBILE
      // No restamos el header
      availableHeight = Math.max(viewportHeight, 200);

      console.log(
        `📱 MOBILE → viewport: ${viewportHeight}px → hero: ${availableHeight}px`
      );

    } else {
      // 🖥️ PC
      // Restamos la altura del header
      const headerHeight = getHeaderHeight();

      availableHeight = Math.max(
        viewportHeight - headerHeight,
        200
      );

      console.log(
        `🖥️ PC → viewport: ${viewportHeight}px, header: ${headerHeight}px → hero: ${availableHeight}px`
      );
    }

    hero.style.setProperty(
      '--hero-min-height',
      availableHeight + 'px'
    );

    const container = hero.querySelector('.hero__container');

    if (container) {
      container.style.minHeight = availableHeight + 'px';
    }
  }

  // Ejecutar cuando el DOM esté listo
  function inicializar() {

    let intentos = 0;
    const maxIntentos = 5;
    const intervalo = 200;

    function intentar() {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      // En mobile no necesitamos esperar al header
      if (isMobile) {
        setHeroHeight();
        console.log("✅ Hero mobile ajustado");
        return;
      }

      // En PC esperamos a que el header tenga altura
      const headerHeight = getHeaderHeight();

      if (headerHeight > 0 || intentos >= maxIntentos) {
        setHeroHeight();
        console.log("✅ Hero PC ajustado");
      } else {
        intentos++;

        console.log(
          `⏳ Header aún sin altura, reintento ${intentos}...`
        );

        setTimeout(intentar, intervalo);
      }
    }

    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      intentar();
    } else {
      document.addEventListener('DOMContentLoaded', intentar);
    }
  }

  inicializar();

})();

// ============================================================
//  ELIMINAR PACK COMPLETO DESDE EL CARRITO
//  Escucha clics en botones con data-is-pack="true"
// ============================================================
// ============================================================
//  ELIMINAR PACK COMPLETO DESDE EL CARRITO (versión mejorada)
// ============================================================

// ============================================================
//  OVERLAY DE CARGA PARA ELIMINAR PACKS (dentro del drawer)
// ============================================================

let packOverlay = null;

function createPackOverlay() {
  // Si ya existe y está en el DOM, devolverlo
  if (packOverlay && document.body.contains(packOverlay)) {
    return packOverlay;
  }

  // Buscar el contenedor del drawer
  const drawer = document.querySelector('cart-drawer-component');
  if (!drawer) {
    console.warn('No se encontró el cart-drawer-component');
    return null;
  }

  // Buscar el contenedor donde poner el overlay (dentro de .cart-drawer__inner)
  const target = drawer.querySelector('.cart-drawer__inner');
  if (!target) {
    console.warn('No se encontró .cart-drawer__inner');
    return null;
  }

  // Asegurar que el contenedor tenga posición relativa
  if (getComputedStyle(target).position === 'static') {
    target.style.position = 'relative';
  }

  // Si ya existe un overlay pero fue removido del DOM, limpiar referencia
  if (packOverlay && !document.body.contains(packOverlay)) {
    packOverlay = null;
  }

  // Crear overlay
  const overlay = document.createElement('div');
  overlay.className = 'pack-remove-overlay';
  overlay.id = 'pack-remove-overlay';
  overlay.innerHTML = `
    <div class="spinner"></div>
    <div class="message">Eliminando pack...</div>
  `;
  
  target.appendChild(overlay);
  packOverlay = overlay;
  return overlay;
}

function showPackOverlay() {
  // Intentar obtener el overlay existente, si no, crearlo
  const overlay = createPackOverlay();
  if (!overlay) return;
  // Forzar reflow para que la transición funcione
  void overlay.offsetWidth;
  overlay.classList.add('active');
}

function hidePackOverlay() {
  if (packOverlay && document.body.contains(packOverlay)) {
    packOverlay.classList.remove('active');
  }
}
// ============================================================
//  LISTENER PARA ELIMINAR PACKS
// ============================================================

document.addEventListener('click', function(e) {
  const removeBtn = e.target.closest('button.cart-items__remove[data-is-pack="true"]');
  if (!removeBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const packId = removeBtn.dataset.packId;
  if (!packId) {
    console.warn('Pack remove: falta data-pack-id');
    return;
  }

  showPackOverlay();

  console.log('🔍 Eliminando pack con ID:', packId);

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      console.log('📦 Productos en el carrito:');
      cart.items.forEach((item, index) => {
        console.log(`  Línea ${index+1}: ${item.product_title} - _pack_id:`, item.properties?._pack_id || 'sin pack');
      });

      const linesToRemove = cart.items
        .map((item, index) => {
          if (item.properties && item.properties._pack_id === packId) {
            return index + 1;
          }
          return null;
        })
        .filter(id => id !== null);

      if (linesToRemove.length === 0) {
        console.warn('⚠️ No se encontraron líneas con packId:', packId);
        hidePackOverlay();
        return;
      }

      const sortedLines = linesToRemove.sort((a, b) => b - a);
      console.log('🗑️ Líneas a eliminar (orden inverso):', sortedLines);

      return sortedLines.reduce((promise, line) => {
        return promise.then(() => {
          console.log(`  Eliminando línea ${line}...`);
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: 0 })
          })
          .then(response => {
            if (response.status === 422) {
              console.warn(`  ⚠️ Línea ${line} ya fue eliminada (422), continuando...`);
              return { ok: true, ignored: true };
            }
            if (!response.ok) {
              throw new Error(`Error ${response.status} al eliminar línea ${line}`);
            }
            return response.json();
          });
        });
      }, Promise.resolve());
    })
    .then(() => {
      console.log('✅ Pack eliminado correctamente');
      return fetch(window.location.pathname);
    })
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newWrapper = doc.querySelector('.cart-items__wrapper');
      const currentWrapper = document.querySelector('.cart-items__wrapper');

      if (newWrapper && currentWrapper) {
        currentWrapper.innerHTML = newWrapper.innerHTML;
        console.log('🔄 Carrito actualizado en el DOM');
      }

      // Disparar evento cart:update
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          sourceId: 'pack-remove',
          data: {
            source: 'pack-remove',
            itemCount: 0,
            sections: {}
          }
        }
      }));

      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.refresh === 'function') {
        drawer.refresh();
      }

      hidePackOverlay();
    })
    .catch(err => {
      console.error('❌ Error al eliminar el pack:', err);
      hidePackOverlay();
    });
});